<template lang="html">

  <section class="home-empresa row-between container ais">

    <div class="contenedor-left">

      <div class="contenedor-home container row-between ais">

        <article class="home-el" v-if="!!procesos" title="Número de ofertas publicadas en este momento">

          <router-link :to="$t('enlaces.mis_ofertas')+'/practicas'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.ofertas_practicas')"></h3>

          <p v-html="$t('home_empresa.texto_ofertas_practicas')"></p>
          <h4 class="bubble" :loading="loading" title="Número de ofertas publicadas en este momento">
            <template v-if="procesosPracticasActivos!= '0'">{{procesosPracticasActivos}}</template>
            <template v-else>0</template>
          </h4>
        </article>

        <article class="home-el">

          <router-link :to="$t('enlaces.nueva_oferta')+'/practicas'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.nueva_practicas')"></h3>

          <p v-html="$t('home_empresa.publicar_practicas')"></p>

          <h4 class="bubble add">+</h4>


        </article>


        <article class="home-el" v-if="!!procesos" title="Número de ofertas publicadas en este momento">

          <router-link :to="$t('enlaces.mis_ofertas')+'/empleo'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.ofertas_empleo')"></h3>

          <p v-html="$t('home_empresa.texto_ofertas_empleo')"></p>
          <h4 class="bubble" :loading="loading" title="Número de ofertas publicadas en este momento">
            <template v-if="procesosEmpleoActivos!= '0'">{{procesosEmpleoActivos}}</template>
            <template v-else>0</template>
          </h4>

        </article>

        <article class="home-el">

          <router-link :to="$t('enlaces.nueva_oferta')+'/empleo'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.nueva_empleo')"></h3>

          <p v-html="$t('home_empresa.texto_nueva_empleo')"></p>

          <h4 class="bubble add">+</h4>

        </article>

      </div>


      <div class="contenedor-encuestas">
        <modulo-encuestas></modulo-encuestas>
      </div>

    </div>

    <div class="container -comunicaciones" v-if="comunicaciones.length > 0">
      <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0">
        <modulo-comunicaciones></modulo-comunicaciones>
      </div>
    </div>


  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import moduloEncuestas from '@/components/views/home/modulo-encuestas'

  import moduloComunicaciones from './modulo-comunicaciones';

  export default {
    name: 'home-empresa',
    mounted() {
      if (this.procesos.length==0 && this.procesos.numProcesosActivosEmpleo==null)
        this.requestNumProcesos();
    },
    components: {
      'modulo-encuestas': moduloEncuestas,
      'modulo-comunicaciones': moduloComunicaciones,
    },
    methods: {
      ...mapActions(['requestNumProcesos']),
    },
    computed: {
      ...mapGetters({
        colors: 'basicColors',
        style: 'getStyles',
        procesos: 'getNumProcesos',
        comunicaciones: 'getComunicaciones',
        loading:'getLoadingProcesos'
      }),
      procesosPracticasActivos: function () {
        let procesos
        if (!!this.procesos) {
          procesos = this.procesos.numProcesosActivosPracticas
        }
        return procesos;
      },
      procesosEmpleoActivos: function () {
        let procesos
        if (!!this.procesos) {
          procesos = this.procesos.numProcesosActivosEmpleo
        }
        return procesos;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';

  .home-empresa {
    max-width: 1200px;
    padding-top: 70px;
    padding-right: 0;
    padding-left: 0;
    min-height: calc(100vh - 309px);
    @media screen and (max-width: 1100px) {
      padding-top: 40px;
    }
  }

  .contenedor-home {
    padding-bottom: 0px;
    max-width: 800px;
  }

  .home-el {
    width: calc(50% - 10px);
    max-width: 380px;
    padding: 25px;
    margin-bottom: 50px;
    text-align: left;
    position: relative;

    &:nth-child(3) {
      margin-bottom: 0;
    }

    &:nth-child(4) {
      margin-bottom: 0;
    }

  }

  .home-el h3 {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 400;
  }

  .bubble {
    position: absolute;
    right: 20px;
    top: 0;
    transform: translateY(-50%);
    height: 55px;
    line-height: 55px;
    width: 55px;
    font-weight: 800;
    text-align: center;
    font-size: 21px;
    border-radius: 100%;

    &[loading=true] {
      font-size: 0;
      background-image: url(/static/img/loading-white.svg);
      background-position: center;
      background-size: 40px auto;
      background-repeat: no-repeat;
    }
  }

  .bubble.add {
    font-size: 36px;
  }

  .container.-comunicaciones {
    width: auto;
  }

  .contenedor-left:first-child:last-child {
    width: 100%;
  }

  @media screen and (max-width: 1185px) {
    .home-empresa {
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-modulo-comunicaciones {
      margin-top: 50px;
      max-width: 768px;
      padding-bottom: 50px;
    }
  }

  @media screen and (max-width: 767px) {

    .contenedor-home {
      padding-top: 0px;
      padding-bottom: 25px;
    }

    .home-el {
      max-width: 100%;
      width: 100%;

      &:nth-child(3) {
        margin-bottom: 50px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/home-empresa.vue